import React, { useEffect, useState } from 'react';
import { Switch, styled } from '@mui/material';
import { useSelector } from 'react-redux';
import useToggleTheme from '../../hooks/useToggleTheme';

const ToggleTheme = () => {
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const [darkMode, setDarkMode] = useToggleTheme();

    return (
        <>
            <button
                onClick={() => setDarkMode(!darkMode)}
                className=" hidden md:flex w-8 h-8 items-center justify-center rounded-md bg-white/10 text-white transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-widget lg:!ml-[5px]"
                aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
                <img
                    src={`${imageBaseUrl}/junoclient/${
                        !darkMode ? 'moon-icon.svg' : 'sun-icon.svg'
                    }`}
                    alt={!darkMode ? 'Moon icon' : 'Sun icon'}
                    className="w-5 h-5"
                    data-e2e="color-mode"
                />
            </button>

            <div className="md:hidden">
                <IOSSwitch
                    // className={`${readOnly && 'jnc-btn-disable'}`}
                    onChange={e => {
                        setDarkMode(e.target.checked);
                    }}
                    checked={darkMode}
                />
            </div>
        </>
    );
};

export default ToggleTheme;

const IOSSwitch = styled(props => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    marginRight: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#12B76A',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            backgroundColor: 'black !important',
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#000000' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));
